import React from "react";
import ImageGallery from "../../components/models/ImageGallery";
import PredictionImageContainer from "../../components/models/PredictionImageContainer";
import SpacingVertical from "../../components/SpacingVertical";
import SpacingHorizontal from "../../components/SpacingHorizontal";
import Table from "../../components/models/Table";
import Colors from "../../constants/Colors";
import "../../components/models/ColumnResponsive.css";
import "../../components/models/HideResponsive.css";
import { ImageObjectDetections } from "../../types/ImageObjectDetections";

interface PredictionContainer {
  title: string;
  description: string;
  image: string | ArrayBuffer | null | undefined;
  images: any[];
  imageIndex: number;
  threshold: number;
  prediction: ImageObjectDetections | null;
  onCameraClick: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onGalleryItemPress: (index: number) => void;
  tableRows: JSX.Element;
}

const PredictionContainer = (props: any) => {
  const {
    title,
    description,
    image,
    images,
    imageIndex,
    prediction,
    threshold,
    onCameraClick,
    onGalleryItemPress,
    tableRows,
  } = props;
  return (
    <div>
      <h1>{title}</h1>
      <p style={styles.textDescription}>{description}</p>
      <SpacingVertical />
      <ImageGallery
        thumbnails={images}
        onCameraClick={onCameraClick}
        onGalleryItemPress={onGalleryItemPress}
      />
      <SpacingVertical />
      <div className="columnResponsive">
        <PredictionImageContainer
          detections={prediction}
          alt="demo images"
          src={image || images[imageIndex]}
          threshold={threshold}
        />
        <SpacingHorizontal className="hideMobile" rems={2} />
        <SpacingVertical className="hideDesktop" rems={2} />
        <Table>{tableRows}</Table>
      </div>
    </div>
  );
};

const styles = {
  error: { color: Colors.primary },
  text: { margin: 0 },
  textDescription: {
    maxWidth: "700px",
  },
};

export default PredictionContainer;
